import React from 'react';

import { StyledAlertWrapper } from './styledAlert';

const AlertMessage = ({message, messageBold, type, mb, mt, ml, mr, className, center, border}) => {
  return (
    <StyledAlertWrapper center={center} className={className} type={type} mt={mt} mb={mb} ml={ml} mr={mr} border={border}>
      <span>{message}{messageBold ? <b>{messageBold}</b> : ''}</span>
    </StyledAlertWrapper>
  )
}

export default AlertMessage